import styled, { css } from "styled-components";
import ArrowLeftIcon from "../icon/arrowLeftIcon";
import { useEffect, useState } from "react";
import ArrowRightIcon from "../icon/arrowRightIcon";
import ChargeExportFirstPage from "./chargeExportFirstPage";
import CustomButton from "../common/customButton";
import CloseIcon from "../icon/closeIcon";
import ChargeExportSecondPage from "./chargeExportSecondPage";
import API from "../../API/API";
import {
  convertCompanyContractImg,
  createCompanyContract,
  updateCompanyContract,
} from "../../API/AppRepository";
import { useNavigate, useParams } from "react-router-dom";
import ChargeExportItemPage from "./chargeExportItemPage";

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2); /* 배경을 약간 어둡게 만듭니다. */
  z-index: 9995; /* 모달보다 아래에 위치하도록 설정합니다. */
`;

const CalculatorComponentWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: white;
  overflow: auto;
  border-radius: 0.8vw;
`;

const Container = styled.div`
  width: 100vw;
  height: 150vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const TopArea = styled.div`
  width: 90%;
  height: 6vw;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 1vw;
`;

const ChargeContainer = styled.div`
  width: 90vw;
  height: 127vw;
  display: flex;
  /* outline: 2px solid red; */
  justify-content: space-around;
  outline: 0.2vw solid #d8d8d8;
  border-radius: 1.3vw;
  align-items: center;
`;

const BottomArea = styled.div`
  width: 90%;
  height: 8vw;
  margin-top: 2vw;
  display: flex;
  /* outline: 1px solid red; */
  justify-content: space-between;
  align-items: center;
`;

const LeftArea = styled.div`
  height: 100%;
  width: 36%;
  /* outline: 1px solid red; */
  display: flex;
  align-items: center;
`;

const MidArea = styled.div`
  width: 28%;
  /* outline: 1px solid red; */
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const RightArea = styled.div`
  height: 100%;
  /* outline: 1px solid red; */
  width: 36%;
  display: flex;
  justify-content: end;
  align-items: center;
`;
const CloseBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  &&:hover {
    cursor: pointer;
  }
`;
const NumBox = styled.div`
  width: 10vw;
  height: 5vw;
  background-color: #e7e7e7;
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.4vw;
  font-weight: 600;
`;
const PrevBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 5vw;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#e7e7e7")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;
const NextBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 5vw;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#e7e7e7")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;

export default function ChargeExportModalComponent(props: any) {
  const { data, setData, isDetailPage, onClose } = props;
  const navigate = useNavigate();
  const { id } = useParams();
  const contractInfo = data.contractInfo; // 1페이지에 필요한 정보
  const chargeList = data.chargeList; // 2,3페이지 이상 필요한 정보
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [prevBoxActive, setPrevBoxActive] = useState<boolean>(false);
  const [nextBoxActive, setNextBoxActive] = useState<boolean>(true);
  const maxIndex = chargeList.length * 2 + 1;

  const clickPrevPage = (e: any) => {
    if (currentPage <= 1) {
      return;
    } else {
      setCurrentPage(currentPage - 1);
    }
  };

  const clickNextPage = (e: any) => {
    if (currentPage >= maxIndex) {
      return;
    }
    setCurrentPage(currentPage + 1);
  };

  // 기업이전 견적서 수정
  const onClickUpdateCompanyContract = async (e: any) => {
    const clientInfo = contractInfo.clientInfo;
    const headInfo = contractInfo.headInfo;
    const detailInfo = contractInfo.detailInfo;
    if (
      clientInfo.companyName &&
      clientInfo.contactPerson &&
      clientInfo.contactNumber &&
      headInfo.companyName &&
      headInfo.contactPerson &&
      headInfo.contactNumber &&
      detailInfo.workDate1 &&
      detailInfo.contractDate &&
      detailInfo.departureAddress1 &&
      detailInfo.destinationAddress1
    ) {
      const requestParam = {
        cmCd: id,
        ...data,
      };
      const result = await updateCompanyContract(requestParam);
      if (result.status === 200) {
        let cmCd = result.data.cmCd;
        await convertCompanyContractImg(e, maxIndex, cmCd, setCurrentPage);
        alert("성공적으로 변경되었습니다.");
        navigate("/enterpriseContractList");
        await new Promise((resolve) => setTimeout(resolve, 1000));
        window.location.reload();
      } else {
        alert("견적서 이미지 생성에 실패했습니다.");
      }
      return;
    }
    alert("필수값을 모두 입력해주세요.");
  };

  // 기업이전 새로운 견적서 생성
  const onClickCreateCompanyContract = async (e: any) => {
    const clientInfo = contractInfo.clientInfo;
    const headInfo = contractInfo.headInfo;
    const detailInfo = contractInfo.detailInfo;
    if (
      clientInfo.companyName &&
      clientInfo.contactPerson &&
      clientInfo.contactNumber &&
      headInfo.companyName &&
      headInfo.contactPerson &&
      headInfo.contactNumber &&
      detailInfo.workDate1 &&
      detailInfo.contractDate &&
      detailInfo.departureAddress1 &&
      detailInfo.destinationAddress1
    ) {
      const result = await createCompanyContract(data);
      if (result.status === 200) {
        let cmCd = result.data.companyMovingData.cmCd;
        await convertCompanyContractImg(e, maxIndex, cmCd, setCurrentPage);
        alert("성공적으로 성공적으로 생성되었습니다.");
        navigate("/enterpriseContractList");
        await new Promise((resolve) => setTimeout(resolve, 1000));
        window.location.reload();
      } else {
        alert("견적서 생성에 실패했습니다.");
      }
      return;
    }
    alert("필수값을 모두 입력해주세요.");
  };

  useEffect(() => {
    if (currentPage <= 1) {
      setPrevBoxActive(false);
      setNextBoxActive(true);
    } else {
      setPrevBoxActive(true);
      if (currentPage >= maxIndex) {
        setNextBoxActive(false);
      } else {
        setNextBoxActive(true);
      }
    }
  }, [currentPage]);

  return (
    <>
      <Backdrop>
        <CalculatorComponentWrapper>
          <Container>
            <TopArea>
              <LeftArea></LeftArea>
              <MidArea>
                <PrevBox $isActivate={prevBoxActive}>
                  <ArrowLeftIcon
                    onClick={(e: any) => clickPrevPage(e)}
                    width={"4.2vw"}
                    height={"4.2vw"}
                    fill={"white"}
                  />
                </PrevBox>
                <NumBox>
                  {currentPage}/{maxIndex}
                </NumBox>
                <NextBox $isActivate={nextBoxActive}>
                  <ArrowRightIcon
                    onClick={(e: any) => clickNextPage(e)}
                    width={"4.2vw"}
                    height={"4.2vw"}
                    fill={"white"}
                  />
                </NextBox>
              </MidArea>
              <RightArea>
                <CloseBox>
                  <CloseIcon
                    height={"3vw"}
                    fill={"#AEAEAE"}
                    onClick={onClose}
                  />
                </CloseBox>
              </RightArea>
            </TopArea>
            <ChargeContainer>
              {currentPage === 1 && (
                <ChargeExportFirstPage
                  contractInfo={contractInfo}
                  chargeList={chargeList}
                ></ChargeExportFirstPage>
              )}
              {currentPage % 2 === 0 && (
                <ChargeExportItemPage
                  contractDate={contractInfo.detailInfo.contractDate}
                  chargeList={chargeList}
                  currentPage={Math.floor(currentPage / 2)}
                  currentId={currentPage}
                ></ChargeExportItemPage>
              )}
              {currentPage > 1 && currentPage % 2 === 1 && (
                <ChargeExportSecondPage
                  contractDate={contractInfo.detailInfo.contractDate}
                  chargeList={chargeList}
                  currentPage={Math.floor(currentPage / 2)}
                  currentId={currentPage}
                ></ChargeExportSecondPage>
              )}

              {/* 
              1장 일때
              maxIndex = 3
              1페이지 = current
              물품정보 =  current - 1 = 1
              산출내역서 = current - 2 = 1

              2장일때
              maxIndex = 5
              1페이지 = current
              물품1 = current - 1 = 1
              산출2 = current -2 = 1
              물품2 = current -3 = 2
              물품2 = current -4 = 2
 
              */}
            </ChargeContainer>
            <BottomArea>
              {isDetailPage ? (
                <CustomButton
                  size="2.4vw"
                  fontWeight="500"
                  width="100%"
                  height="6.4vw"
                  text="견적서 수정완료"
                  radius="0.8vw"
                  onClick={onClickUpdateCompanyContract}
                ></CustomButton>
              ) : (
                <CustomButton
                  size="2.4vw"
                  fontWeight="500"
                  width="100%"
                  height="6.4vw"
                  text="견적서 생성하기"
                  radius="0.8vw"
                  onClick={onClickCreateCompanyContract}
                ></CustomButton>
              )}
            </BottomArea>
          </Container>
        </CalculatorComponentWrapper>
      </Backdrop>
    </>
  );
}
